module.exports = __webpack_public_path__ + "img/feedback_correct_dark.473eacbd.png";